
import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-vehicle-sessions-link',
  templateUrl: './vehicle-sessions-link.component.html',
  styleUrls: ['./vehicle-sessions-link.component.scss']
})
export class VehicleSessionsLinkComponent implements OnInit, AfterViewChecked {
   res:any;
   language:any;
   invinnumber:any;
   getApiRes:any
   displayHTML: any;
   viewContent = false;
   displayContent = false
   getHTMLData: boolean = false;
   countViewChecked: number = 0;
   printText: string = '';

  constructor(private service:ApifirstService, private activateRoute: ActivatedRoute, private translate: TranslateService, private router: Router) { }

  ngOnInit(): void {
      this.res=localStorage.getItem("tokenObj")
      let result = JSON.parse(this.res)
      console.log(result)
      
    this.activateRoute.queryParams.subscribe(data => {
      const id = data['id']
      const type = data['type']
      const token = data["token"];
      this.service.rapToken.next(token);
      this.language = data['language'];
      this.printText = data['printText'];
      this.translate.use(this.language.toLowerCase());
      if(type.toUpperCase() === "SPA"){
        this.displayContent = false
        this.service.getViewDetailsofFDRS(id,this.language.toLowerCase(),data['country'],data['marketCountry'],"SPA",this.printText,data['userName'], data['userType']).subscribe((data) => {
          this.getApiRes = data;
          this.testHtml();
         
        })
      }
      else{
        this.displayContent = true
        this.service.getViewDetailsofFDRS(id,this.language.toLowerCase(),data['country'],data['marketCountry'],"Procedure",this.printText,data['userName'], data['userType']).subscribe((data) => {
          this.getApiRes = data;
          this.testHtml();
         
        })
      }
    })
  }

  ngAfterViewChecked() {
    if(this.displayHTML && this.countViewChecked == 0) {
      this.countViewChecked++;
      const pinpointLinks = document.querySelectorAll("a[href]");
      const buttonLinks = document.querySelectorAll("input[onclick]");
      pinpointLinks.forEach(link => {
        let href: any = link.getAttribute('href');
        let extras: NavigationExtras = {
          relativeTo: this.activateRoute,
          queryParamsHandling: 'merge',
        };
        if(href[0]=='#' || href=='') {
          extras.queryParams = this.activateRoute.snapshot.params;
          if(href[0]=='#'){
            extras.fragment = href.slice(1);
          }
          link.addEventListener('click', ()=>{
            this.router.navigate([],extras);
          });
        }else if(href[0]== 'G' || href[0]=='p') {
          // do nothing
        }else {
          const query: any[] = href.split('?');
          let params = JSON.parse('{"' + decodeURI(query[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
          extras.queryParams = params;
          link.addEventListener('click', ()=>{
            this.service.getViewDetailsofFDRSRedirect(href).subscribe((data)=>{
              this.countViewChecked = 0;
              this.getApiRes = data;
              this.testHtml();
              this.router.navigate([],extras);
            })
          });
        }
        link.setAttribute('href','javascript:void(0)');
      })
      buttonLinks.forEach(link => {
        link.setAttribute('onclick','javascript:void(0)');
      })
      const headers = document.querySelectorAll("th");
      headers.forEach(header => header.setAttribute('style','border-width: 1px'));
      const tableData = document.querySelectorAll("td[valign='top']");
      for(let i=0; i<tableData.length; i++){
        let childNodeLength: number;
        let row: number = i%3;
        if(row == 0){
          childNodeLength = Math.min(tableData[i].childNodes.length,tableData[i+1].childNodes.length,tableData[i+2].childNodes.length);
        }else if(row == 1){
          childNodeLength = Math.min(tableData[i].childNodes.length,tableData[i+1].childNodes.length);
        }else{
          childNodeLength = tableData[i].childNodes.length;
        }
        let style = tableData[i].getAttribute('style');
        if(childNodeLength == 0){
          if(style){
            tableData[i].setAttribute('style',style);
          }
        }else{
          if(style){
            tableData[i].setAttribute('style',tableData[i].getAttribute('style')+' border-width: 1px');
          }else{
            tableData[i].setAttribute('style','border-width: 1px');
          }
        }
      }
    }
  }

  testHtml(){
    this.viewContent =true;
    this.displayHTML = this.getApiRes;
    if(this.displayHTML) {
      this.getHTMLData = true;
    }else {
      this.getHTMLData = false;
    }
  }

  closePage() {
    window.close();
  }
  

}
